// extracted by mini-css-extract-plugin
export default {"currency-selector":"CurrencySelector_currency-selector__PPGgU","label":"CurrencySelector_label__3kNN8"};